/**
 * RNNoise processor using Jitsi's rnnoise-wasm library
 * Designed for manual WASM loading, compatible with Webpack
 */
class RnnoiseProcessor {
    constructor() {
        this.initialized = false;
    }

    /**
     * Initialize the processor
     * Note: Actual RNNoise initialization happens in the AudioWorklet
     */
    async init() {
        console.log('[RNNoise] Processor ready');
        this.initialized = true;
    }

    /**
     * Create RNNoise AudioWorkletNode
     * @param {AudioContext} context - Must be 48kHz sample rate for RNNoise
     * @returns {Promise<AudioWorkletNode>}
     */
    async createNode(context) {
        if (!this.initialized) {
            throw new Error('RnnoiseProcessor not initialized. Call init() first.');
        }

        // Verify sample rate
        if (context.sampleRate !== 48000) {
            console.warn(`[RNNoise] Context sample rate is ${context.sampleRate}Hz. RNNoise works best at 48kHz.`);
        }

        try {
            // Load our custom bundled worklet processor
            const workletPath = '/wasm/rnnoise-worklet-bundled.js';
            console.log('[RNNoise] Loading worklet:', workletPath);

            await context.audioWorklet.addModule(workletPath);

            // Create the worklet node
            const node = new AudioWorkletNode(context, 'rnnoise-processor', {
                numberOfInputs: 1,
                numberOfOutputs: 1,
                outputChannelCount: [1], // Force Mono output
                channelCount: 2, // Request Stereo input (to isolate Left channel)
            });

            console.log('[RNNoise] AudioWorkletNode created successfully');
            return node;
        } catch (error) {
            console.error('[RNNoise] Failed to create node:', error);
            throw error;
        }
    }
}

// Export singleton instance
export const rnnoiseProcessor = new RnnoiseProcessor();
